// extracted by mini-css-extract-plugin
export default {"uploadLabel":"uploader_uploadLabel__ku9NM","trash":"uploader_trash__OpDGH"};